import Loadable from 'react-loadable';
import Loader from '../../components/UIComponents/Loader';

export const LoadableSteelSection = Loadable({
  loader: () => import('./SteelSection'),
  loading: Loader
});
